// extracted by mini-css-extract-plugin
export default {"statsCard_outer":"StatsCard_statsCard_outer__EAAVc"};